import React, {useEffect} from 'react';
import PubSub from 'services/PubSub/';
import Drawer from "components/Drawers/Drawer";
import FeedbackRegister from 'components/Drawers/DrawerFeedbackRegister/FeedbackRegister';
import PrimeService from 'services/Prime';
import StorageService from 'services/StorageService/';
import { actionsType } from 'config/constants';
import style from './style.scss'; //NOSONAR

let actions = [];

const DrawerFeedbackRegister = () => {

    useEffect(() => {
        actions.push(PubSub.register(actionsType.DRAWER.FEEDBACK_REGISTER_CLOSE, _updateUserInfo));

        return function cleanup() {
            actions.map(token => PubSub.unregister(token));
            actions = [];
        }
    }, [])

    const _updateUserInfo = () => {

        let userData = StorageService.getSecureItem('userData');

        PrimeService.primeDate().then(result => {
            userData.prime_invitation_date =  result.date;
            StorageService.setSecureItem('userData', userData);
        })

        PrimeService.countOrderUser(userData.countOrder)

    }

    return (
        <Drawer customClass='drawer-feedback-register' actionOpen={actionsType.DRAWER.FEEDBACK_REGISTER_OPEN} actionClose={actionsType.DRAWER.FEEDBACK_REGISTER_CLOSE}>
            <FeedbackRegister />
        </Drawer>
    );
}

export default DrawerFeedbackRegister;
